import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=1479091c&scoped=true"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"
import style0 from "./Email.vue?vue&type=style&index=0&id=1479091c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479091c",
  null
  
)

export default component.exports